class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	// cap how many cart lines we query, so a large cart doesn't fan out into many requests
	static get MAX_SOURCES(){ return 5; }

	generateRecommendations(){
		const cartForm = document.getElementById('AjaxCartForm');
		if ( !cartForm ) return;

		const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length === 0 ) {
			this.innerHTML = '';
			return;
		}

		// unique product ids currently in the cart, in the order they appear
		const cartProductIds = [];
		cartItems.forEach(item => {
			const id = item.dataset.productId;
			if ( id && cartProductIds.indexOf(id) === -1 ) cartProductIds.push(id);
		});

		const limit = parseInt(this.dataset.limit, 10) || 6;
		const sources = cartProductIds.slice(0, CartRecommendations.MAX_SOURCES);
		const token = (this._token = (this._token || 0) + 1);

		// one request per cart line — Shopify's endpoint accepts a single product_id
		const requests = sources.map(productId =>
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${productId}&limit=${limit}&intent=complementary`)
				.then(response => response.text())
				.then(text => new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]'))
				.catch(() => null)
		);

		Promise.all(requests).then(results => {
			// a newer cart update already started while these were in flight
			if ( token !== this._token ) return;

			const shell = results.find(node => node && node.querySelector('[data-js-product-item]'));
			if ( !shell ) {
				this.innerHTML = '';
				return;
			}

			// merge every response, keeping cart order, skipping duplicates and what's already in the cart
			const seen = [];
			const merged = [];
			results.forEach(node => {
				if ( !node ) return;
				node.querySelectorAll('[data-js-product-item]').forEach(item => {
					if ( merged.length >= limit ) return;
					const id = item.dataset.productId;
					if ( id && (cartProductIds.indexOf(id) !== -1 || seen.indexOf(id) !== -1) ) return;
					if ( id ) seen.push(id);
					merged.push(item);
				});
			});

			if ( merged.length === 0 ) {
				this.innerHTML = '';
				return;
			}

			const grid = shell.querySelector('.grid');
			if ( grid ) {
				grid.innerHTML = '';
				merged.forEach(item => grid.appendChild(item));
			}

			this.innerHTML = shell.innerHTML;
		});
	}
}
customElements.define('cart-recommendations', CartRecommendations);
